import { Box, HStack, Text, VStack } from '@cdl/heartbeat-react';
import { AnnotationTask } from '../../../../ecg/types/annotation-tasks.type';

type AnnotationStatus = 'done' | 'pending' | 'toStart';
interface Props {
  annotationTask: AnnotationTask;
  status: AnnotationStatus;
}

export const OverallCount: React.FC<Props> = ({ annotationTask, status }) => {
  const getStatusDetails = (status: AnnotationStatus) => {
    switch (status) {
      case 'done':
        return {
          count: annotationTask.ecgDoneCount,
          color: 'green.400',
          label: 'Completed',
        };
      case 'pending':
        return {
          count: annotationTask.ecgPendingCount,
          color: 'orange.400',
          label: 'Pending',
        };
      case 'toStart':
      default:
        return {
          count: annotationTask.ecgToStartCount,
          color: 'red.400',
          label: 'To start',
        };
    }
  };

  const { count, color, label } = getStatusDetails(status);

  return (
    <HStack alignItems='top'>
      <Text fontSize='s' fontWeight='semibold' color={color}>
        {count}/{annotationTask.ecgTotalCount}
      </Text>
      <VStack alignItems='left' spacing={0}>
        <Text fontSize='s'>{label}</Text>
        {status === 'pending' && (
          <Box gap='s'>
            {annotationTask.ecgPendingDetail &&
              Object.entries(annotationTask.ecgPendingDetail).map(
                ([key, val], i) => (
                  <Text fontSize='xs' key={i}>
                    - ECGs with {key}/{annotationTask.nbAnnotations} annotations
                    done: {val}
                  </Text>
                ),
              )}
          </Box>
        )}
      </VStack>
    </HStack>
  );
};
